import {ZodError, type ZodType} from 'zod';

import {processZodErrors} from './helpers';
import {RequestStatus} from './types';

export const updateFieldHelper = (
  context: {formData: Record<string, unknown>},
  event: {type: string; field?: string; value?: unknown},
) => {
  if (event.type !== 'UPDATE_FIELD' || !event.field) return {};

  const {field, value} = event;
  const formData = {...context.formData, [field]: value};

  return {formData};
};

export const validateFieldHelper = (
  formData: unknown,
  schema: ZodType,
): {errors?: Record<string, string>; requestStatus?: RequestStatus} => {
  try {
    schema.parse(formData);

    return {errors: {}, requestStatus: RequestStatus.IDLE};
  } catch (error) {
    if (error instanceof ZodError) {
      const fieldErrors = processZodErrors(error);

      return {errors: fieldErrors};
    }

    throw error;
  }
};
